import { render, staticRenderFns } from "./ABBanner.vue?vue&type=template&id=66e4016a&"
import script from "./ABBanner.vue?vue&type=script&lang=js&"
export * from "./ABBanner.vue?vue&type=script&lang=js&"
import style0 from "./ABBanner.vue?vue&type=style&index=0&id=66e4016a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports